/* eslint-disable */
import axios from '@/axios.js';

export const appointmentApi = {
  getAppointments(payload) {
    return axios.get('admin/appointments?join=appointmentOrder&join=advisor&join=user', {
      params: payload,
    });
  },
  getAppointment(id) {
    return axios.get(`admin/appointments/${id}?join=appointmentOrder&join=advisor&join=user`);
  },
  updateAppointment(id, body) {
    return axios.patch(`admin/appointments/${id}`, body);
  },
};
